import React from "react";
import { Button, Modal } from "react-bootstrap";
import "../../../stylesheets/components/Reports/PositionReports/PnlReport/ConfirmationPopup.scss";
import { useNavigate } from "react-router-dom";
import di from "@frameworks/web/components/features/LoginFlow/di/servicelocator";
import orderbookDi from "@frameworks/web/components/features/OrderBook/di/servicelocator";
var ConfirmationPopup = function (props) {
    var _a;
    var splitedText = (_a = props === null || props === void 0 ? void 0 : props.description) === null || _a === void 0 ? void 0 : _a.split(". ");
    var navigate = useNavigate();
    React.useEffect(function () {
        var handleKeyDown = function (event) {
            if ((props === null || props === void 0 ? void 0 : props.popTitle) == "Session Expired!" && (event === null || event === void 0 ? void 0 : event.key) === "Escape") {
                di === null || di === void 0 ? void 0 : di.login.flushLoginData();
                orderbookDi === null || orderbookDi === void 0 ? void 0 : orderbookDi.flushOrderBookErrorData();
                localStorage.removeItem("acc_data");
                localStorage.removeItem("jwt_token");
                localStorage.removeItem("user_id");
                localStorage.removeItem("lgnSrc");
                localStorage.removeItem("accountCode");
                localStorage.removeItem("guest_acc_data");
                sessionStorage.clear();
                window.location.reload();
                navigate("/login");
            }
        };
        window.addEventListener("keydown", handleKeyDown);
        return function () {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    return (React.createElement("div", { className: "ed-generic-modal-edit" },
        React.createElement("div", { className: "modal-dialog modal-dialog-centered" },
            React.createElement(Modal, { className: "ed-generic-modal ".concat(props.popTitle, " "), show: props.show, "data-backdrop": "static", "data-keyboard": "false", centered: true, contentClassName: "".concat(props.popupClass) },
                React.createElement(Modal.Header, { className: "ed-generic-header", onClick: function () {
                        if (props.setShow)
                            props.setShow(false);
                    } },
                    React.createElement(Modal.Title, null, props.popTitle)),
                React.createElement(Modal.Body, null,
                    props.description && (React.createElement(React.Fragment, null,
                        splitedText[0],
                        ".",
                        React.createElement("br", null),
                        " ",
                        splitedText[1],
                        " ")),
                    props.children),
                props.showFooter && (React.createElement(Modal.Footer, { className: "ed-generic-off-footer" },
                    props.goBackBtn ? (React.createElement(Button, { className: "go-back", onClick: props.btnFirstCta }, props.btnFirstTitle)) : (React.createElement(Button, { className: "review-changes", onClick: props.btnFirstCta }, props.btnFirstTitle)),
                    React.createElement(Button, { className: "confirm", onClick: props.btnSecCta }, props.btnSecTitle)))))));
};
export default ConfirmationPopup;
